const STORAGE_KEY = 'flashMessage';

/** Queue a message to be shown as a toast right after the next navigation. */
export function setFlashMessage(message: string): void {
  sessionStorage.setItem(STORAGE_KEY, message);
}

export function consumeFlashMessage(): string | null {
  const message = sessionStorage.getItem(STORAGE_KEY);
  if (message) sessionStorage.removeItem(STORAGE_KEY);
  return message;
}
